import { serializable, primitive, object, list, alias } from 'serializr';

class OrganizationLocation {
  @serializable(primitive())
  id?: number;
}

class Address {
  @serializable(primitive())
  city?: string;

  @serializable(primitive())
  street?: string;

  @serializable(primitive())
  province?: string;

  @serializable(alias('postal_code', primitive()))
  postalCode?: string | null;

  @serializable(primitive())
  country?: string;

  @serializable(alias('country_code', primitive()))
  countryCode?: string;

  @serializable(primitive())
  latitude?: string;

  @serializable(primitive())
  longitude?: string;

  @serializable(alias('province_code'))
  provinceCode?: string;
}

class Year {
  @serializable(primitive())
  year?: number;

  @serializable(alias('share_percentage', primitive()))
  sharePercentage?: string | number;
}

class Location {
  @serializable(primitive())
  name?: string;

  @serializable(primitive())
  category?: string | number;

  @serializable(object(OrganizationLocation))
  organization?: OrganizationLocation;

  @serializable(object(Address))
  address?: Address;

  @serializable(list(object(Year)))
  years?: Year[];
}

class DataPayload {
  @serializable(list(object(Location)))
  locations?: Location[];
}

export class CreateLocationsPayload {
  @serializable(object(DataPayload))
  data?: DataPayload;
}
